(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fault-code-lookup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SEV_ORDER = { critical: 0, warning: 1, info: 2 };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
    });
  }
  function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  // "E-3" / "e 3" / "  41 " all collapse to the same comparable token.
  function normCode(s) { return String(s || '').toLowerCase().replace(/[\s_.\-\/]/g, ''); }
  function norm(s) { return String(s || '').toLowerCase(); }

  function setup(root) {
    if (root.getAttribute('data-fcl-ready')) return;
    root.setAttribute('data-fcl-ready', '1');

    var input = root.querySelector('.fcl__input');
    var clearBtn = root.querySelector('.fcl__clear');
    var results = root.querySelector('.fcl__results');
    var status = root.querySelector('.fcl__status');
    var empty = root.querySelector('.fcl__empty');
    var filters = root.querySelector('[data-fcl-filters]');
    var brandBox = root.querySelector('.fcl__brands');
    var motorOnly = root.querySelector('[data-fcl-motor-only]');
    var refsBox = root.querySelector('[data-fcl-refs]');

    var limit = parseInt(root.getAttribute('data-limit'), 10) || 25;
    var motorUrl = root.getAttribute('data-motor-url') || '';
    var motorLabel = root.getAttribute('data-motor-label') || 'Shop replacement motors';

    var codes = [];
    var brand = '';
    var ready = false;

    function currentQuery() { return input.value.trim(); }

    // ---- scoring ---------------------------------------------------------
    function score(rec, q) {
      var nq = normCode(q);
      var nc = normCode(rec.code);
      var s = -1;

      if (nq) {
        if (nc === nq) s = 1000;
        else if (nc.indexOf(nq) === 0) s = 700;
        else {
          for (var i = 0; i < rec.aliases.length; i++) {
            if (normCode(rec.aliases[i]) === nq) { s = 900; break; }
          }
          if (s < 0 && normCode(rec.display) === nq) s = 850;
        }
      }

      // Word search across title / meaning / system / brand.
      var words = norm(q).split(/\s+/).filter(Boolean);
      if (words.length) {
        var hay = norm(rec.title + ' ' + rec.meaning + ' ' + rec.system + ' ' +
                       rec.brand + ' ' + rec.alsoBrands.join(' ') + ' ' +
                       rec.appliesTo.join(' ') + ' ' + rec.causes.join(' '));
        var all = true, ts = 0;
        for (var w = 0; w < words.length; w++) {
          if (hay.indexOf(words[w]) === -1) { all = false; break; }
          if (norm(rec.title).indexOf(words[w]) !== -1) ts += 40;
        }
        if (all) s = Math.max(s, 100 + ts);
      }
      return s;
    }

    function mark(text, q) {
      var out = esc(text);
      var words = norm(q).split(/\s+/).filter(function (w) { return w.length > 1; });
      if (!words.length) return out;
      try {
        var re = new RegExp('(' + words.map(escRe).join('|') + ')', 'ig');
        return out.replace(re, '<mark>$1</mark>');
      } catch (e) { return out; }
    }

    // ---- rendering -------------------------------------------------------
    // Each list gets its own filled box so causes and checks read as two
    // distinct things rather than one run of bullets.
    function boxHtml(title, items, variant) {
      if (!items || !items.length) return '';
      return '<div class="fcl__box fcl__box--' + variant + '">' +
        '<p class="fcl__box-t">' + esc(title) + '</p><ul class="fcl__list">' +
        items.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div>';
    }

    // The rebadge list and the equipment list are far too long for the
    // collapsed row, so they live here instead of being clamped away.
    function specHtml(rec) {
      var rows = [];
      if (rec.alsoBrands && rec.alsoBrands.length) {
        rows.push(['Also sold as', rec.alsoBrands.join(', ')]);
      }
      if (rec.appliesTo && rec.appliesTo.length) {
        rows.push(['Applies to', rec.appliesTo.join(', ')]);
      }
      if (!rows.length) return '';
      return '<dl class="fcl__spec">' + rows.map(function (r) {
        return '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>';
      }).join('') + '</dl>';
    }

    function gridHtml(rec) {
      var a = boxHtml('Likely causes', rec.causes, 'causes');
      var b = boxHtml('What to check', rec.checks, 'checks');
      if (!a && !b) return '';
      return '<div class="fcl__grid' + (a && b ? '' : ' fcl__grid--single') + '">' + a + b + '</div>';
    }

    function itemHtml(rec, q, open) {
      var sev = SEV_ORDER[rec.severity] === undefined ? 'info' : rec.severity;
      // Brand and system only: the row clamps its meta to a single line, and
      // the rebadges and equipment list are shown in full once it is open.
      var metaBits = [rec.brand, rec.system].filter(Boolean);

      var tags = '<span class="fcl__tag fcl__tag--' + sev + '">' + esc(sev) + '</span>';
      if (rec.motor) tags += '<span class="fcl__tag fcl__tag--motor">motor</span>';

      var cta = '';
      if (rec.motor && motorUrl) {
        cta = '<div class="fcl__cta">' +
              '<p class="fcl__cta-b">This code points at a blower, inducer or condenser fan motor. ' +
              'We stock OEM and Genteq equivalents with extended warranty - send us your model number and ' +
              'we will confirm the exact match before you order.</p>' +
              '<a class="fcl__cta-btn button-primary" href="' + esc(motorUrl) + '">' + esc(motorLabel) + '</a>' +
              '</div>';
      }

      return '<details class="fcl__item fcl__item--' + sev + '" id="' + esc(slug(rec)) + '"' + (open ? ' open' : '') + '>' +
        '<summary class="fcl__sum">' +
          '<span class="fcl__code">' + esc(rec.display) + '</span>' +
          '<span class="fcl__head">' +
            '<span class="fcl__name">' + mark(rec.title, q) + '</span>' +
            '<span class="fcl__meta">' + metaBits.map(esc).join(' &middot; ') + '</span>' +
          '</span>' +
          '<span class="fcl__tags">' + tags + '</span>' +
          // Same chevron the theme uses on its collapsible product tabs.
          '<svg class="fcl__caret" width="8" height="6" viewBox="0 0 8 6" fill="none" aria-hidden="true">' +
            '<path d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"/>' +
            '<path d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"/>' +
          '</svg>' +
        '</summary>' +
        '<div class="fcl__body">' +
          '<p class="fcl__meaning">' + esc(rec.meaning) + '</p>' +
          specHtml(rec) +
          gridHtml(rec) +
          cta +
          '<p class="fcl__src">Source: <a href="' + esc(rec.source.url) + '" rel="nofollow noopener" target="_blank">' +
            esc(rec.source.label) + '</a></p>' +
        '</div>' +
      '</details>';
    }

    function slug(rec) {
      return 'code-' + normCode(rec.brand) + '-' + normCode(rec.code);
    }

    function render() {
      if (!ready) return;
      var q = currentQuery();
      var motorFlag = motorOnly && motorOnly.checked;

      var pool = codes.filter(function (r) {
        if (brand && r.brand !== brand) return false;
        if (motorFlag && !r.motor) return false;
        return true;
      });

      var picked;
      if (!q) {
        // No query: show the brand's list (or nothing until a brand is picked).
        if (!brand && !motorFlag) {
          results.innerHTML = '';
          empty.hidden = true;
          status.textContent = codes.length + ' fault codes loaded across ' +
            (root.__brands || []).length + ' brands. Enter a code, or pick a brand to browse.';
          return;
        }
        picked = pool.slice().sort(function (a, b) {
          if (a.brand !== b.brand) return a.brand < b.brand ? -1 : 1;
          if (a.system !== b.system) return a.system < b.system ? -1 : 1;
          return codeSort(a, b);
        });
      } else {
        var scored = [];
        for (var i = 0; i < pool.length; i++) {
          var s = score(pool[i], q);
          if (s >= 0) scored.push({ r: pool[i], s: s });
        }
        scored.sort(function (a, b) {
          if (b.s !== a.s) return b.s - a.s;
          var sa = SEV_ORDER[a.r.severity], sb = SEV_ORDER[b.r.severity];
          if (sa !== sb) return sa - sb;
          return a.r.brand < b.r.brand ? -1 : (a.r.brand > b.r.brand ? 1 : 0);
        });
        picked = scored.map(function (x) { return x.r; });
      }

      var total = picked.length;
      var shown = picked.slice(0, limit);

      if (!total) {
        results.innerHTML = '';
        empty.hidden = false;
        status.textContent = 'No results for "' + q + '"' + (brand ? ' in ' + brand : '') + '.';
        return;
      }

      empty.hidden = true;
      // Auto-expand when the answer is unambiguous.
      var autoOpen = shown.length === 1 || (q && shown.length && score(shown[0], q) >= 850 &&
        (shown.length === 1 || score(shown[1], q) < 850));

      results.innerHTML = shown.map(function (r, idx) {
        return itemHtml(r, q, autoOpen && idx === 0);
      }).join('');

      status.textContent = total > shown.length
        ? 'Showing ' + shown.length + ' of ' + total + ' matches - refine your search to narrow it down.'
        : total + (total === 1 ? ' match' : ' matches') + (brand ? ' in ' + brand : '') + '.';

      syncUrl(q);
    }

    function codeSort(a, b) {
      var na = parseInt(a.code, 10), nb = parseInt(b.code, 10);
      var aNum = !isNaN(na), bNum = !isNaN(nb);
      if (aNum && bNum && na !== nb) return na - nb;
      if (aNum !== bNum) return aNum ? -1 : 1;
      return a.code < b.code ? -1 : (a.code > b.code ? 1 : 0);
    }

    // ---- deep linking ----------------------------------------------------
    var urlTimer = null;
    function syncUrl(q) {
      if (!window.history || !history.replaceState) return;
      clearTimeout(urlTimer);
      urlTimer = setTimeout(function () {
        try {
          var u = new URL(window.location.href);
          if (q) { u.searchParams.set('code', q); } else { u.searchParams.delete('code'); }
          if (brand) { u.searchParams.set('brand', brand); } else { u.searchParams.delete('brand'); }
          history.replaceState(null, '', u.toString());
        } catch (e) { /* older browsers: skip */ }
      }, 400);
    }

    function readUrl() {
      try {
        var p = new URL(window.location.href).searchParams;
        var b = p.get('brand');
        if (b) {
          for (var i = 0; i < (root.__brands || []).length; i++) {
            if (root.__brands[i].toLowerCase() === b.toLowerCase()) { brand = root.__brands[i]; break; }
          }
        }
        var c = p.get('code');
        if (c) input.value = c;
      } catch (e) { /* ignore */ }
    }

    // ---- brand chips -----------------------------------------------------
    function buildBrands(brands) {
      var html = '<button type="button" class="fcl__chip" data-fcl-brand="" aria-pressed="' +
        (brand ? 'false' : 'true') + '">All brands</button>';
      html += brands.map(function (b) {
        return '<button type="button" class="fcl__chip" data-fcl-brand="' + esc(b) + '" aria-pressed="' +
          (brand === b ? 'true' : 'false') + '">' + esc(b) + '</button>';
      }).join('');
      brandBox.innerHTML = html;
      filters.hidden = false;
    }

    function selectBrand(b) {
      brand = b || '';
      brandBox.querySelectorAll('[data-fcl-brand]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-fcl-brand') === brand ? 'true' : 'false');
      });
      render();
    }

    // ---- references ------------------------------------------------------
    function buildRefs(refs) {
      if (!refsBox || !refs || !refs.length) return;
      refsBox.querySelector('.fcl__refs-list').innerHTML = refs.map(function (r) {
        return '<li><span class="fcl__refs-brand">' + esc(r.brand) + '</span>' +
          '<a href="' + esc(r.url) + '" rel="nofollow noopener" target="_blank">' + esc(r.label) + '</a>' +
          '<span class="fcl__refs-note">' + esc(r.note) + '</span></li>';
      }).join('');
      refsBox.hidden = false;
    }

    // ---- events ----------------------------------------------------------
    var debounce = null;
    input.addEventListener('input', function () {
      clearBtn.hidden = !input.value;
      clearTimeout(debounce);
      debounce = setTimeout(render, 120);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(debounce); render(); }
      else if (e.key === 'Escape') { input.value = ''; clearBtn.hidden = true; render(); }
    });
    clearBtn.addEventListener('click', function () {
      input.value = ''; clearBtn.hidden = true; input.focus(); render();
    });
    var goBtn = root.querySelector('.fcl__go');
    if (goBtn) {
      goBtn.addEventListener('click', function () {
        clearTimeout(debounce);
        render();
        input.focus();
      });
    }
    root.addEventListener('click', function (e) {
      var bEl = e.target.closest('[data-fcl-brand]');
      if (bEl) { selectBrand(bEl.getAttribute('data-fcl-brand')); return; }
      var exEl = e.target.closest('[data-fcl-example]');
      if (exEl) {
        input.value = exEl.getAttribute('data-fcl-example');
        clearBtn.hidden = false;
        render();
        input.focus();
      }
    });
    if (motorOnly) motorOnly.addEventListener('change', render);

    // ---- load ------------------------------------------------------------
    var src = root.getAttribute('data-src');
    fetch(src, { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        codes = (data.codes || []).map(function (r) {
          r.alsoBrands = r.alsoBrands || [];
          r.aliases = r.aliases || [];
          r.appliesTo = r.appliesTo || [];
          r.causes = r.causes || [];
          r.checks = r.checks || [];
          r.display = r.display || r.code;
          return r;
        });
        root.__brands = data.brands || [];
        ready = true;
        readUrl();
        buildBrands(root.__brands);
        buildRefs(data.references);
        clearBtn.hidden = !input.value;
        render();
        if (input.value) {
          var first = results.querySelector('.fcl__item');
          if (first) first.scrollIntoView({ block: 'nearest' });
        }
      })
      .catch(function (err) {
        status.textContent = 'The fault code database could not be loaded. Please refresh the page or contact us and we will look your code up for you.';
        if (window.console && console.warn) console.warn('[fault-code-lookup]', err);
      });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-fcl]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center-hub"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.hch2Ready) return;
    root.dataset.hch2Ready = '1';

    var groups = root.querySelectorAll('[data-hch2-group]');
    var panels = root.querySelectorAll('[data-hch2-panel]');
    var moreCards = root.querySelectorAll('[data-hch2-more]');
    var heroTitle = root.querySelector('[data-hch2-hero-title]');
    var heroDesc = root.querySelector('[data-hch2-hero-desc]');
    var crumb = root.querySelector('[data-hch2-crumb]');
    var search = root.querySelector('[data-hch2-search]');
    var noResults = root.querySelector('[data-hch2-noresults]');

    function activate(handle, scroll) {
      var found = false;
      panels.forEach(function (p) {
        var on = p.getAttribute('data-hch2-panel') === handle;
        p.hidden = !on;
        p.classList.toggle('is-active', on);
        if (on) {
          found = true;
          if (heroTitle) heroTitle.textContent = p.getAttribute('data-hch2-title') || '';
          if (heroDesc) heroDesc.textContent = p.getAttribute('data-hch2-desc') || '';
          if (crumb) crumb.textContent = p.getAttribute('data-hch2-title') || '';
        }
      });
      if (!found) return;
      groups.forEach(function (g) {
        var on = g.getAttribute('data-hch2-group') === handle;
        g.classList.toggle('is-active', on);
        if (on) g.classList.add('is-open');
        var btn = g.querySelector('[data-hch2-group-btn]');
        if (btn) btn.setAttribute('aria-expanded', g.classList.contains('is-open') ? 'true' : 'false');
      });
      moreCards.forEach(function (c) {
        var on = c.getAttribute('data-hch2-more') === handle;
        c.hidden = on;
        c.classList.toggle('is-active', on);
      });
      if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    groups.forEach(function (g) {
      var btn = g.querySelector('[data-hch2-group-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var handle = g.getAttribute('data-hch2-group');
        if (g.classList.contains('is-active')) {
          g.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', g.classList.contains('is-open') ? 'true' : 'false');
        } else {
          activate(handle, false);
        }
      });
    });

    moreCards.forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        var handle = c.getAttribute('data-hch2-more');
        activate(handle, true);
        if (window.history && history.replaceState) history.replaceState(null, '', '#topic-' + handle);
      });
    });

    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        root.classList.toggle('is-searching', q.length > 0);
        var any = false;
        groups.forEach(function (g) {
          var hit = false;
          g.querySelectorAll('[data-hch2-item]').forEach(function (item) {
            var match = q === '' || (item.getAttribute('data-hch2-t') || '').indexOf(q) !== -1;
            item.hidden = !match && q !== '';
            if (match) hit = true;
          });
          g.hidden = q !== '' && !hit;
          if (hit && q !== '') any = true;
        });
        if (noResults) noResults.hidden = q === '' || any;
      });
    }

    var hash = (window.location.hash || '').replace('#topic-', '');
    if (hash) activate(hash, false);
    else if (panels.length) activate(panels[0].getAttribute('data-hch2-panel'), false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hch2]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center-search"] && !Shopify.designMode) return;
  try {
    
(function () {
  var counter = 0;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
    });
  }
  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function setup(root) {
    if (root.getAttribute('data-hcs-ready')) return;
    root.setAttribute('data-hcs-ready', '1');
    var uid = 'hcs' + (++counter);

    var dataEl = root.querySelector('.hcs__data');
    var index = [];
    try { index = JSON.parse((dataEl && dataEl.textContent) || '[]'); } catch (e) { index = []; }
    var seen = {};
    index = index.filter(function (it) {
      if (!it || !it.u || !it.t || seen[it.u]) return false;
      seen[it.u] = 1; return true;
    });

    var input = root.querySelector('.hcs__input');
    var results = root.querySelector('.hcs__results');
    var empty = root.querySelector('.hcs__empty');
    var clearBtn = root.querySelector('.hcs__clear');
    var current = [], active = -1;

    function norm(s) { return (s || '').toLowerCase(); }

    function score(it, words) {
      var t = norm(it.t), c = norm(it.c), hay = t + ' ' + c;
      for (var i = 0; i < words.length; i++) { if (hay.indexOf(words[i]) === -1) return -1; }
      var s = 0, phrase = words.join(' ');
      if (t.indexOf(phrase) === 0) s += 120;
      else if (t.indexOf(phrase) !== -1) s += 60;
      if (t.indexOf(words[0]) === 0) s += 30;
      if (t.indexOf(words[0]) !== -1) s += 10;
      return s;
    }

    function mark(text, words) {
      var esc = escapeHtml(text);
      if (!words.length) return esc;
      var re = new RegExp('(' + words.map(escapeRe).join('|') + ')', 'ig');
      return esc.replace(re, '<mark>$1</mark>');
    }

    function close() {
      results.hidden = true; results.innerHTML = ''; empty.hidden = true;
      active = -1; input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function render(q) {
      var words = norm(q).split(/\s+/).filter(Boolean);
      if (!words.length) { close(); return; }
      var scored = [];
      for (var i = 0; i < index.length; i++) {
        var sc = score(index[i], words);
        if (sc >= 0) scored.push({ it: index[i], s: sc });
      }
      scored.sort(function (a, b) { return b.s - a.s; });
      current = scored.slice(0, 12).map(function (x) { return x.it; });
      active = -1;
      if (!current.length) {
        results.hidden = true; results.innerHTML = '';
        empty.hidden = false; input.setAttribute('aria-expanded', 'false');
        return;
      }
      empty.hidden = true;
      results.innerHTML = current.map(function (it, idx) {
        return '<a class="hcs__item" role="option" id="' + uid + '-opt-' + idx + '" href="' + encodeURI(it.u) + '">'
          + '<span class="hcs__item-t">' + mark(it.t, words) + '</span>'
          + (it.c ? '<span class="hcs__item-c">' + escapeHtml(it.c) + '</span>' : '')
          + '</a>';
      }).join('');
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function setActive(i) {
      var items = results.querySelectorAll('.hcs__item');
      if (!items.length) return;
      if (i < 0) i = items.length - 1;
      if (i >= items.length) i = 0;
      active = i;
      for (var k = 0; k < items.length; k++) items[k].classList.toggle('is-active', k === active);
      input.setAttribute('aria-activedescendant', items[active].id);
      items[active].scrollIntoView({ block: 'nearest' });
    }

    input.addEventListener('input', function () {
      clearBtn.hidden = !input.value;
      render(input.value);
    });
    input.addEventListener('keydown', function (e) {
      var items = results.querySelectorAll('.hcs__item');
      if (e.key === 'ArrowDown') { e.preventDefault(); if (results.hidden) render(input.value); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Enter') { if (active >= 0 && items[active]) { e.preventDefault(); window.location.href = items[active].getAttribute('href'); } }
      else if (e.key === 'Escape') { close(); }
    });
    input.addEventListener('focus', function () { if (input.value) render(input.value); });
    clearBtn.addEventListener('click', function () { input.value = ''; clearBtn.hidden = true; close(); input.focus(); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hcs]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
